import axios from '../shared/axios';
import * as events from './events';

export function saveProposal(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/Proposal/SaveProposal`, data)
            .then(result => {
                events.onNotification_CREATED();
                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function updateProposal(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/Proposal/Update`, data)
            .then(result => {
                switch (data.actioncode) {
                    case 'SAVE_DRAFT':
                        events.onNotification_DRAFT_SAVED();
                        break;
                    case 'COMMUNICATE':
                        events.onNotification_COMMUNICATED();
                        break;
                    case 'REPLY_DRAFT':
                        events.onNotification_REPLY_DRAFT_SAVED();
                        break;
                    case 'REPLY_SEND':
                        events.onNotification_REPLY_SENT();
                        break;
                    default:
                        alert('Unknown action code!');
                        break;
                }
                resolve(result);
            })
            .catch(error => reject(error));
    });
}
export function getProposal(proposalid) {
    return axios.get(`/api/Proposal/GetProposal?earlyproposalid=${proposalid}`);
}

export function getProposals(companyid, projectid, contractid, accessibleWfIds) {
    return axios.post(`/api/Proposal/LoadProposalsList`, { accessibleWfIds }, { params: { companyid, projectid, contractid } });
}
export function deleteProposalDraft(proposalid) {
    return new Promise((resolve, reject) => {
        axios.post(`api/Proposal/DeleteDraft?proposalid=${proposalid}`)
            .then(result => {
                events.onNotification_DELETED();
                resolve(result);
            })
            .catch(error => reject(error));
    })
}
export function importProposals(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.post(`/api/Proposal/Import`, data);
            events.onNotification_CREATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function deleteProposalDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.delete(`/api/Proposal/BulkDeleteDraft`, { data: data });
            events.onNotification_DELETED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function communicateProposalDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.put(`/api/Proposal/BulkCommunicate`, data);
            events.onNotification_COMMUNICATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}